// extracted by mini-css-extract-plugin
export default {"root":"base_root__+2mJM","p2":"base_p2__-Y00R"};